import React from 'react'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { Form, FormLongTextInput, FormMultiSelectInput, FormTextInput } from '@superhi/design'

import { API } from '../../../../../api'
import BaseForm from '../../../_templates/BaseForm'
import InputImage from '../../../../../components/InputImage'

import { FormValues } from './types'
import QUERY from './queries'
import MUTATION from './mutations'
import { FIELDS, VALIDATION_SCHEMA } from './config'

const MembershipAffiliatesUpdate: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { id } = useParams<any>()
  const { data } = useQuery<API.resources_update, API.resources_updateVariables>(QUERY, {
    variables: {
      id,
    },
  })

  if (!data?.resource) {
    return null
  }

  return (
    <BaseForm<FormValues, API.resources_update_mutationVariables>
      mutation={MUTATION}
      validationSchema={VALIDATION_SCHEMA}
      initialValues={{
        description: data?.resource.description,
        image: {
          url: data?.resource.image.url,
          value: '',
          file: null,
        },
        tags: data.resource.tags,
        url: data?.resource.url,
        title: data?.resource.title,
      }}
      createVariablesFn={(values) => ({
        ...values,
        id,
        image: values.image.file,
      })}
    >
      <Form.Rows>
        <FormTextInput {...FIELDS.TITLE} />
        <FormLongTextInput {...FIELDS.DESCRIPTION} />
        <InputImage {...FIELDS.IMAGE} />
        <FormTextInput {...FIELDS.URL} />
        <FormMultiSelectInput {...FIELDS.TAGS} />
      </Form.Rows>
    </BaseForm>
  )
}

export default MembershipAffiliatesUpdate
